import React, { useEffect, useRef, useState } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { useDispatch } from "react-redux";
import HttpClient from "../../../../utils/HttpClient";
import toast from "react-hot-toast";
import "./AverageChart.css";
import DashboardManager3 from "../../dashboard/DashboardManager3";
import GanttChart from "../../../TaskManager/GanttChart";
import EventsCalender from "../../../TaskManager/EventsCalender";
import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
import RiskManagement from "../../../TaskManager/RiskManagement";
import {
  reset_balance_dashboard3,
  reset_current_total_bar3,
  reset_current_total_line3,
  reset_current_vs_actual_budget_bar3,
  reset_current_vs_actual_budget_line3,
  reset_expense_bar_chart,
  reset_expense_bar_chart3,
  reset_expense_line_chart,
  reset_expense_line_chart3,
  reset_expense_per_bar_graph,
  reset_expense_per_bar_graph3,
  reset_expense_per_line_graph,
  reset_expense_per_line_graph3,
  reset_kanban_data,
  reset_kanban_data3,
  reset_open_acc_receive,
  reset_open_acc_receive3,
  reset_profit_line_chart,
  reset_profit_line_chart3,
  reset_sales_line_chart,
  reset_sales_line_chart3,
  reset_task_at_risk3,
  reset_task_complete_status3,
  reset_task_deviation_analysis3,
  reset_tax_line3,
  reset_tax_pie3,
  reset_transaction_dashboard3,
  set_balance_dashboard3,
  set_current_total_bar3,
  set_current_total_line3,
  set_current_vs_actual_budget_bar3,
  set_current_vs_actual_budget_line3,
  set_expense_bar_chart,
  set_expense_bar_chart3,
  set_expense_line_chart,
  set_expense_line_chart3,
  set_expense_per_bar_graph,
  set_expense_per_bar_graph3,
  set_expense_per_line_graph,
  set_expense_per_line_graph3,
  set_open_acc_receive,
  set_open_acc_receive3,
  set_profit_line_chart,
  set_profit_line_chart3,
  set_sales_line_chart,
  set_sales_line_chart3,
  set_task_at_risk3,
  set_task_complete_status3,
  set_task_deviation_analysis3,
  set_tax_line3,
  set_tax_pie3,
  set_transaction_dashboard3,
  toggle_Kanban_data,
  toggle_Kanban_data3,
} from "../../../../redux/reducers/favDashboardSlice";
import { useUserData } from "../../../../Providers/UserWrapper";
import Loader from "../../../../Loader/Loader";
import { useSelector } from "react-redux";
import RiskManagement3 from "../../../TaskManager/RiskManagement3";
import { useLanguage } from "../../../../Providers/LanguageContext";

const data = [
  { name: "1", value: 300 },
  { name: "2", value: 520, label: "+18%" },
  { name: "3", value: 430 },
  { name: "4", value: 830 },
  { name: "5", value: 480, label: "-10%" },
  { name: "6", value: 620 },
  { name: "7", value: 350 },
  { name: "8", value: 500, label: "+27%" },
  { name: "9", value: 820 },
];

export default function AverageChart() {
  const { taskCompletionStatus3, taskAtRisk3, taskDeviationAnalysis3 } =
    useSelector((state) => state?.favDashboard);
  const { setIsLoading } = useUserData();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [widgetsFour, setwidgetsFour] = useState([]);
  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);
  const componentRef = useRef(null);
  const { language } = useLanguage();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchWidgetOneData = async () => {
    try {
      setIsLoading(true);
      const res = await HttpClient.requestData("dashboard", "GET");
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        setwidgetsFour(res?.widgets?.four || []);
      } else {
        console.log("error", res);
        setwidgetsFour([]);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  useEffect(() => {
    if (widgetsFour) {
      setSelectedWidgetOne(widgetsFour?.find((item) => item?.visible) || null);
    }
  }, [widgetsFour]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
    setTimeout(() => {
      scrollToComponent();
    }, 100);
  };

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data3());
      dispatch(reset_open_acc_receive3());
      dispatch(reset_expense_per_line_graph3());
      dispatch(reset_expense_per_bar_graph3());
      dispatch(reset_expense_bar_chart3());
      dispatch(reset_expense_line_chart3());
      dispatch(reset_profit_line_chart3());
      dispatch(reset_sales_line_chart3());
      dispatch(reset_task_complete_status3());
      dispatch(reset_task_deviation_analysis3());
      dispatch(reset_task_at_risk3());
      dispatch(reset_current_total_bar3());
      dispatch(reset_current_total_line3());
      dispatch(reset_current_vs_actual_budget_bar3());
      dispatch(reset_current_vs_actual_budget_line3());
      dispatch(reset_transaction_dashboard3());
      dispatch(reset_balance_dashboard3());
      dispatch(reset_tax_line3());
      dispatch(reset_tax_pie3());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data3());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive3());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph3());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph3());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart3());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart3());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart3());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart3());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status3());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis3());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk3());
          break;

        case "current total (bar graph)":
          dispatch(set_current_total_bar3());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line3());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar3());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line3());
          break;
        case "Balance dashboard":
          dispatch(set_balance_dashboard3());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard3());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie3());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line3());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  const scrollToComponent = () => {
    if (componentRef.current) {
      const element = componentRef.current;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleAddWidget = async (widget) => {
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        fetchWidgetOneData();
        setSelectedWidgetOne(widget);
        closeModal();
        setTimeout(() => {
          scrollToComponent();
        }, 100);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  return (
    <>
      <div className="average-chart-wrapper" ref={componentRef}>
        {!selectedWidgetOne && <Loader />}
        <div className="calendar-wrapper-mc">
          <div className="calendar-header-mc">
            <h3 class="chart-title-mc">{selectedWidgetOne?.name?.toUpperCase() ||
              "Average Risk"?.toUpperCase()}</h3>
            <i
              className="fa-regular fa-pen-to-square edit-icon-mc"
              onClick={openModal}
            ></i>
          </div>
        </div>
        {/* <div className="average-chart-header">
          <div>
            <h3 className="average-chart-title">
              {selectedWidgetOne?.name?.toUpperCase() ||
                "Average Risk"?.toUpperCase()}
            </h3>
          </div>
          <div className="icons-dc">
            <i
              className="fa-regular fa-pen-to-square icon-dc"
              onClick={openModal}
            ></i>
          </div>
        </div> */}
        {/* Render widget components based on selection */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && (
          <DashboardManager3 />
        )}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement3
            taskCompleteStatus={taskCompletionStatus3}
            taskAtRisk={taskAtRisk3}
            taskDeviationAnalysis={taskDeviationAnalysis3}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement3
            taskCompleteStatus={taskCompletionStatus3}
            taskAtRisk={taskAtRisk3}
            taskDeviationAnalysis={taskDeviationAnalysis3}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement3
            taskCompleteStatus={taskCompletionStatus3}
            taskAtRisk={taskAtRisk3}
            taskDeviationAnalysis={taskDeviationAnalysis3}
          />
        )}

        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager3 />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager3 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager3 />
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase()}
            </h3>

            <div className="gd-modal-list">
              {widgetsFour?.length > 0 ? (
                widgetsFour?.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
